/* eslint-disable import/no-import-module-exports */
import React from 'react';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { initializeAmplitude } from 'utils/amplitude';
import { SessionService } from 'modules/session/sessionService';
import validateSession, { refreshUser } from 'utils/validateSession';
import config from 'xland-ui/config';
import { FILES_BASE_URL } from 'constants/apiConf';
import App from './routes/App';
import initialState from './store/globalState/initialState';
import configureStore from './store/configureStore';
import './styles/index.scss';

initializeAmplitude();

config.setConfig({
  apiUrl: FILES_BASE_URL,
});

Sentry.init({
  dsn: window.SENTRY_DSN,
  environment: window.SENTRY_ENVIRONMENT,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: window.SENTRY_SAMPLE_RATE || 0,
});

if (module.hot) {
  module.hot.accept();
}

const store = configureStore(initialState);
SessionService.initSessionService(store, validateSession, refreshUser)
  .then(() => {
    SessionService.loadSession().catch(validateSession);
  });

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

// unregister();
// registerServiceWorker();
